import { ImageContent, LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import ItemEditor from "../ItemEditor"
import { useLandingStore, ILandingStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface IPassageItemEditFormProps {
   i:number
   primitive: ImageContent
   children: JSX.Element
   items: any[]
}
const PassageItemEditForm = (props: IPassageItemEditFormProps): JSX.Element => {
   const isEdit: boolean = useLandingStore((state: ILandingStore) => state.isEdit )
   return isEdit
      ?
      <>
         { props.children }
         <ItemEditor i={props.i} item={props.primitive} type={LANDING_TYPE_CONTENT.PASSAGE} items={props.items} />
      </>
      :
      <>{props.children}</>
}
export default PassageItemEditForm